import {
  Box,
  DashboardModule,
  Image,
  ListItem,
  Text,
  ToggleButton,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import type { UseFormPayload } from '@domain-group/react-hooks'

import useBrand from '@hooks/useBrand'

import useBrandImageSettings from '../../hooks/useBrandImageSettings'

import agencyIcon1 from '../../assets/agencyIcon1.svg'

interface ImageSettingsPermissionsModuleProps {
  brandId: number,
  formPayload: UseFormPayload,
}

const ImageSettingsPermissionsModule = (props: ImageSettingsPermissionsModuleProps) => {
  const { brandId, formPayload } = props

  const { entityState, setEntityState } = formPayload

  const stateBrandControlledImageSettings = digObject(entityState, 'options.brand_controlled_image_settings_enabled', false)

  const {
    brand,
    callbacks: {
      manageBrandImageSettingsPermissions,
    },
  } = useBrand({ id: brandId })

  const brandControlledImageSettings = digObject(brand, 'options.brand_controlled_image_settings_enabled', false)

  const brandImageSettingsPayload = useBrandImageSettings({ brandId })
  const {
    callbacks: {
      updateBrandImagePermissions,
    },
    excludedAgenciesCount,
  } = brandImageSettingsPayload

  const agencyString = excludedAgenciesCount === 1 ? 'Agency does' : 'Agencies do'

  return (
    // @ts-expect-error TS2322
    <DashboardModule title="Image Settings Permissions" flexDirection="column">
      <Box flexDirection="column">
        <ListItem
          boxProps={{
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: 'large',
          }}
          disableHover
        >
          <Text fontSize="small">Use Brand Image Settings</Text>

          <ToggleButton
            onClick={() => updateBrandImagePermissions(
              stateBrandControlledImageSettings,
              entityState,
              setEntityState,
            )}
            toggleOn={stateBrandControlledImageSettings}
            toggleOffText="No"
            toggleOnText="Yes"
          />
        </ListItem>

        {brandControlledImageSettings && (
          <ListItem
            boxProps={{
              alignItems: 'center',
              borderTop: '1px solid',
              justifyContent: 'space-between',
              padding: 'large',
            }}
            showAngleIcon
            onClick={() => manageBrandImageSettingsPermissions()}
          >
            <Box marginRight="large" style={{ width: '50px', height: '50px' }}>
              <Image style={{ backgroundSize: 'contain' }} url={agencyIcon1} />
            </Box>

            <Box flexDirection="column">
              <Text fontSize="large">{excludedAgenciesCount}</Text>

              <Text
                color="grey"
                fontSize="xsmall"
                fontWeight="500"
                marginTop="medium"
              >
                {agencyString} not use brand image settings
              </Text>
            </Box>
          </ListItem>
        )}
      </Box>
    </DashboardModule>
  )
}

export default ImageSettingsPermissionsModule
